import React from 'react';
import { Link } from 'react-router';

import styles from './Breadcrumbs.scss';

interface BreadcrumbItemProps {
  title: string;
  url: string;
  image?: string;
}

const BreadcrumbItem = ({ title, url, image }: BreadcrumbItemProps) => {
  return (
    <>
      &nbsp;&gt;&nbsp;
      <Link to={url}>
        {image && <img className={styles.Breadcrumbs__Icon} src={image} />}
        {title}
      </Link>
    </>
  );
};

interface BreadcrumbsProps {
  links: BreadcrumbItemProps[];
}

const Breadcrumbs = ({ links }: BreadcrumbsProps) => {
  return (
    <nav className={styles.Breadcrumbs}>
      <Link to="/">Piczel.tv</Link>
      {links.map((link, i) => (
        <BreadcrumbItem key={`link:${i}`} {...link} />
      ))}
    </nav>
  );
};

export default Breadcrumbs;
